import * as server from "@/utils/http"

export const _page = params => server.get("/batch-input-log/page", params);

export const _download = params => server.get("/batch-input-log/download", params);
